import React from 'react';
import Supervisor from 'components/Tvendo/Sale/DataMaster/Supervisor/List.js';

export default function () {
  return <Supervisor />;
}
